import React, { useState } from "react";
import { createPortal } from "react-dom";
import Backdrop from "../common/Backdrop";
import LocationForNotSignIN from "./LocationForNotSignIN";
import useLocation from "../../hooks/useLocation";
import useBodyScrollLock from "../../hooks/useBodyScrollLock";
import { LocationIcon } from "../../assets/icons";
function LocationSelector({setAuthOpen}) {
    const [open, setOpen] = useState(false);

    const { location, updateLocation, detectLocation } = useLocation();

    useBodyScrollLock(open);

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                className="
                flex items-center gap-2
                font-light
                border border-[#80808063]
                p-[9px]
                
                rounded
                text-[13px]
                text-left
                text-white
                truncate
                cursor-pointer
            "
            >
                <LocationIcon size={20} />
                <span className="truncate">{location}</span>
            </button>

            {open &&
                createPortal(
                    <>
                        <Backdrop
                            isOpen={open}
                            onClose={() => setOpen(false)}
                        />

                        <div className="fixed inset-0 z-50 flex items-center justify-center">
                            <div className="bg-white rounded-lg w-[320px] shadow-2xl">
                                <LocationForNotSignIN
                                    setAuthOpen={setAuthOpen}
                                    onClose={() => setOpen(false)}
                                    updateLocation={updateLocation}
                                    detectLocation={detectLocation}
                                    setOpen={setOpen}
                                />
                            </div>
                        </div>
                    </>,
                    document.body
                )}
        </>
    );
}

export default LocationSelector;